import { Link } from "react-router-dom";
import "./header.sass";
import { LogoIcon } from "@components/library";

export const HeaderUnauth = () => {
  return (
    <header className="header header--fixed">
      <div className="header__wrapper">
        <div className="header__left">
          <>
            <Link to="/">
              <LogoIcon />
            </Link>
          </>
        </div>

        {/*<Unauthorized />*/}
      </div>
    </header>
  );
};
